import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import {
  getPublishedProjectsThunk,
  getPublishedProjectsTotalThunk,
} from './thunks'

const publishedProjectsSlice = createSlice({
  name: 'publishedProjects',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPublishedProjectsThunk.pending, (state, action) => {
      state.fetching = true

      const nextSearch = action.meta.arg?.search ?? ''
      const nextTransactionType = action.meta.arg?.transactionType ?? ''
      const nextSort = action.meta.arg?.sort ?? state.sort
      const shouldClearProjects =
        nextSearch !== state.search ||
        nextTransactionType !== state.transactionType ||
        nextSort !== state.sort
      const shouldReset = !action.meta.arg?.skip || shouldClearProjects

      if (shouldReset) {
        state.hasMore = true
        state.skip = 0
        if (shouldClearProjects) {
          state.projects = []
        }
        state.loaded = false
      }
    })
    builder.addCase(getPublishedProjectsThunk.fulfilled, (state, action) => {
      const {
        projects,
        skip = 0,
        count,
        search,
        transactionType,
        sort,
        total,
      } = action.payload

      if (!skip) {
        state.projects = projects
      } else {
        const existingIds = new Set(state.projects.map((project) => project.id))
        const newProjects = projects.filter(
          (project) => !existingIds.has(project.id)
        )
        state.projects = [...state.projects, ...newProjects]
      }

      state.fetching = false
      state.loaded = true
      state.skip = skip + projects.length
      state.pageSize = count ?? state.pageSize
      state.hasMore = projects.length === (count ?? state.pageSize)
      state.search = search ?? ''
      state.transactionType = transactionType ?? ''
      state.sort = sort ?? state.sort
      if (typeof total === 'number') {
        state.total = total
      }
    })
    builder.addCase(getPublishedProjectsThunk.rejected, (state) => {
      state.fetching = false
    })
    builder.addCase(getPublishedProjectsTotalThunk.pending, (state) => {
      state.totalFetching = true
    })
    builder.addCase(
      getPublishedProjectsTotalThunk.fulfilled,
      (state, action) => {
        state.totalAvailable = action.payload
        state.totalFetching = false
        state.totalLoaded = true
      }
    )
    builder.addCase(getPublishedProjectsTotalThunk.rejected, (state) => {
      state.totalFetching = false
      state.totalLoaded = true
      state.totalAvailable = 0
    })
  },
})

export default publishedProjectsSlice.reducer
